import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgxModalDraggableDirective } from '../../../../directives/draggable.directive';
import { TelegramService } from '../../telegram.service';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import { InterfaceService } from '../../../../services/interface.service';

@Component({
  selector: 'app-modal-sender-register',
  templateUrl: './modal-sender-register.component.html',
  styleUrls: ['./modal-sender-register.component.scss']
})
export class ModalSenderRegisterComponent implements OnInit, OnDestroy {
  @Input() telegramService: TelegramService;
  public modalDirective: NgxModalDraggableDirective;

  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }


  constructor(
    public interfaceService: InterfaceService,
    public authService: AuthService,
  ) {
  }

  ngOnInit(): void {
  }



  ngOnDestroy() {
    this.authService.mode$.next('Старт');
  }
}
